import * as React from "react";
import { confirmAlert } from "react-confirm-alert";

import "node_modules/react-confirm-alert/src/react-confirm-alert.css";
import "./SimpleConfirmAlert.css";

export const SimpleAlert = (message: React.ReactNode): Promise<void> => {
    return new Promise(resolve => {
        confirmAlert({
            title: "",
            message: message as any,
            onClickOutside: () => resolve(),
            onKeypressEscape: () => resolve(),
            buttons: [
                {
                    label: "OK",
                    onClick: () => resolve()
                }
            ]
        });
    });
};

export const SimpleConfirmation = (message: React.ReactNode, title = "Are you sure?"): Promise<boolean> => {
    return new Promise(resolve => {
        confirmAlert({
            title,
            message: message as any,
            onClickOutside: () => resolve(false),
            onKeypressEscape: () => resolve(false),
            buttons: [
                {
                    label: "No",
                    onClick: () => resolve(false)
                },
                {
                    label: "Yes",
                    onClick: () => resolve(true)
                }
            ]
        });
    });
};



// WEBPACK FOOTER //
// ./src/components/common/SimpleConfirmAlert.tsx